import styled from 'styled-components';

export const HeadingWrapper = styled.div`
  margin-bottom: 32px;
`;

export const ButtonWrapper = styled.div`
  button {
    margin-right: 16px;
    border-width: 1px;
    font-weight: 600;

    &.decline-button {
      &:disabled {
        background: #dfe3e7;
        border: 1px solid #a0aab7;
        color: #a0aab7;
      }
    }

    &.approve-button {
      &:disabled {
        background: #b3b3b3;
        border: 1px solid #b3b3b3;
        color: #d9d9d9;
      }
    }

    &.success {
      background: #fff;
      border-color: #007b88;
      color: #007b88;
      padding-top: 13px;
      padding-bottom: 15px;

      svg path {
        fill: #007b88;
      }

      &:disabled {
        background: #dfe3e7;
        border: 1px solid #a0aab7;
        color: #a0aab7;

        svg path {
          fill: #a0aab7;
        }
      }
    }

    &.error {
      background: #fff;
      border-color: #fa5245;
      color: #fa5245;
      padding-top: 13px;
      padding-bottom: 15px;

      svg path {
        fill: #fa5245;
      }

      &:disabled {
        background: #dfe3e7;
        border: 1px solid #a0aab7;
        color: #a0aab7;

        svg path {
          fill: #a0aab7;
        }
      }
    }

    svg {
      margin-left: 5px;
      width: 18px;
      height: 18px;
      transform: translate(0px, 3px);
    }
  }
`;

export const Status = styled.span<any>`
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  ${(props) => props.status === 'APPROVED' && `color: #007B88;`}
  ${(props) => props.status === 'DECLINED' && `color: #FA5245;`}
  ${(props) => (!props.status || props.status === 'AWAITING_ASSESSMENT') && `color: #CB7813;`}
`;

export const UpdatedInformation = styled.p`
  margin: 16px 0;
  color: #2d3540;
  font-size: 16px;
`;
